import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Textarea from 'react-textarea-autosize'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

const StyledSidebarInputField = styled.div`
  font-style: normal;
  font-weight: 400;
  display: flex;
`

const StyledInputField = styled(Textarea)`
  max-height: 200px;
  min-height: 94px;
  line-height: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  border-radius: 3px;
  padding: 8px 8px 8px 8px !important;
  width: 100%;
  overflow: auto;
  outline: none;
  border: 1px solid ${colors.secondary70};

  &:focus {
    border: 1px solid ${colors.primary40};
  }
`

const StyledSubmitButton = styled(IconLink)`
  margin-left: 10px;
`

const SidebarTextArea = ({ value, placeholder, fieldName, disabled, onChange }) => {
  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const handleObjectUpdate = () => {
    onChange(inputValue, fieldName)
  }

  const updateInputValue = (event) => {
    setInputValue(event.target.value)
  }

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      setInputValue(value)
    }
  }

  return (
    <StyledSidebarInputField>
      <StyledInputField
        disabled={disabled}
        maxLength={1000}
        type='text'
        placeholder={placeholder}
        value={inputValue}
        onChange={updateInputValue}
        onKeyDown={onKeyDown}
      />
      <StyledSubmitButton
        disabled={disabled}
        onClick={handleObjectUpdate}
        iconName='icon-confirm'
      />
    </StyledSidebarInputField>
  )
}

SidebarTextArea.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  fieldName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default SidebarTextArea
